import { axiosGet } from '@/api/AxiosApi';
import { sendRequest, EndpointPayload } from '@/api/AxiosRequest';
import { ReadCoinTypesParams } from '@/types/stake-db';

const BALANCE_API_URL = process.env.REACT_APP_BALANCE_API_URL;

// 코인타입 목록 조회
export const readCoinTypes = async (params?: ReadCoinTypesParams) => {
  const queryParams = new URLSearchParams();

  if (params?.page !== undefined) {
    queryParams.append('page', String(params.page));
  }
  if (params?.limit !== undefined) {
    queryParams.append('limit', String(params.limit));
  }

  const queryString = queryParams.toString();
  const path = `/assetfi/admin/staking/coin-types${queryString ? `?${queryString}` : ''}`;

  const payload: EndpointPayload = {
    path,
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  return await sendRequest(payload, 'readCoinTypes', axiosGet);
};

// 코인타입 상세 조회
export const readCoinTypeDetail = async (coinTypeId: string) => {
  const payload: EndpointPayload = {
    path: `/assetfi/admin/staking/coin-types/${coinTypeId}`,
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  return await sendRequest(payload, 'readCoinTypeDetail', axiosGet);
};
